import React from 'react';
import { SelectField, TextField } from 'react-admin';
import PropTypes from 'prop-types';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import TextFieldWithPrice from '../../../components/TextFieldWithPrice';
import EjectedBooleanField from '../../../components/ejected/BooleanField';
import TextLabelWithDate from '../../../components/TextFieldWithDate';
import ClientNameButton from '../../../components/ClientNameButton';
import EjectedSelectField from '../../../components/ejected/SelectField';


const Datagrid = ({
  create, edit, total, companies, callcenters, roles, toggleEdit, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    {...rest}
  >
    <TextField source="number" label="#" customstyles={{ width: '30px', backgroundColor: '#2c9bc3' }} />
    <ClientNameButton
      source="fio"
      label="ФИО"
      edit={toggleEdit}
      customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }}
    />
    <TextField source="phone" label="Телефон" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} />
    <TextField source="subject_text" label="Вопрос" customstyles={{ width: '140px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithPrice source="sum" label="Сумма" customstyles={{ width: '70px', backgroundColor: '#2c9bc3' }} />
    <TextField source="feedCount" label="Зап." customstyles={{ width: '40px', backgroundColor: '#2c9bc3' }} />
    <TextLabelWithDate
      source="_createdAt"
      label="Время"
      customstyles={{
        width: '85px',
      }}
      costilniiKostil
    />
    <EjectedBooleanField
      source="treaty"
      label="Договор"
      customstyles={{
        background: '#B29C6A',
        width: '50px'
      }}
      color="#B29C6A"
    />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  edit: null,
  create: null,
  // companies: [],
  // callcenters: [],
  // roles: []
};

Datagrid.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  toggleEdit: PropTypes.func,
  // companies: PropTypes.arrayOf(PropTypes.shape({
  //   id: PropTypes.string.isRequired,
  //   name: PropTypes.string.isRequired
  // })),
  // callcenters: PropTypes.arrayOf(PropTypes.shape({
  //   id: PropTypes.string.isRequired,
  //   name: PropTypes.string.isRequired
  // })),
  // roles: PropTypes.arrayOf(PropTypes.shape({
  //   id: PropTypes.string.isRequired,
  //   name: PropTypes.string.isRequired
  // }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/company/clients/Datagrid.js